import './App.scss';
import styled from 'styled-components';
import axios from 'axios';
import { AppSettingsStateProvider } from './context/AppSettingsStateContext';
import { AuthContextProvider } from './context/AuthContext';

// Use fetch adapter for HTTP/2 support
axios.defaults.adapter = 'fetch';
import { ConnectionProvider } from './context/ConnectionContext';
import AppRouter from './route/AppRouter';
import { DateProvider } from './context/DateContext';
import { EventProvider } from './context/EventContext';
import { AppContextProvider } from './context/AppContext';
import { EventTypeProvider } from './context/EventTypeContext';
import { RotationProvider } from './context/RotationContext';
import { VesselProvider } from './context/VesselContext';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faSearch,
    faSearchPlus,
    faTimesCircle,
    faShip,
    faSort,
    faSortUp,
    faSortDown,
    faTimes,
    faList,
    faPlus,
    faMinus,
    faSignInAlt,
    faSignOutAlt,
    faCog,
    faGripHorizontal,
    faChevronLeft,
    faUser,
    faUserCircle,
    faCheck,
    faArchive,
    faFileAlt,
    faCalendarCheck,
    faChevronRight,
    faCaretRight,
    faExclamationCircle,
    faCheckCircle,
    faChevronDown,
    faChevronUp,
    faFilter,
    faCodeBranch,
    faThumbtack,
    faDolly,
    faFill,
    faPencilAlt,
    faStarOfLife,
    faWater,
    faMinusCircle,
    faMinusSquare,
    faBell,
    faWifi,
    faPen,
    faEdit,
    faPenSquare,
    faTrash,
    faArrowsAlt,
    faArrowCircleRight,
    faArrowCircleLeft,
    faArrowLeft,
    faCircle,
    faNotEqual,
    faExclamationTriangle,
    faExclamation,
    faSlidersH,
    faSortAmountUp,
    faSortAmountDown,
    faSortAmountDownAlt,
    faTh,
    faClock,
    faExchangeAlt,
    faInfoCircle,
    faExternalLinkAlt,
    faPrint,
    faProjectDiagram,
    faEnvelope,
    faQuestionCircle,
    faEllipsisV,
    faEllipsisH,
    faInfo,
    faBroom,
    faDatabase,
    faStar,
    faComment,
    faTemperatureHigh,
    faListOl,
    faCertificate,
    faTable,
    faChartLine,
    faArrowUp,
    faArrowDown,
    faAngleDoubleDown,
    faAngleDoubleLeft,
    faAngleDoubleUp,
    faAngleDoubleRight,
    faGasPump,
    faEye,
    faExternalLinkSquareAlt,
    faCompress,
    faBars,
    faWindowClose,
    faUpload,
    faBan,
    faSyncAlt,
    faHandPointer,
    faRotateLeft,
    faRotateRight,
    faUpDownLeftRight,
    faWeightHanging,
    faScaleUnbalancedFlip,
    faCaretDown,
    faCopy,
    faShareFromSquare,
    faBook,
    faChevronCircleDown,
    faChevronCircleUp,
    faFilePdf,
    faFileExcel,
    faUndo,
    faArrowsAltH,
    faRefresh,
    faLock,
    faUnlock,
} from '@fortawesome/free-solid-svg-icons';
import { AolProvider } from './context/AolContext';
import { Toaster } from 'react-hot-toast';
import theme from './theme';
import { TankCleaningProvider } from './context/TankCleaningContext';
import { LoaderContextProvider } from './context/LoaderContext';
import { UserSettingsContextProvider } from './context/UserSettingsContext';
import { CargoTempLogProvider } from './context/CargoTempLogContext';
import { VerificationProvider } from './context/VerificationContext';
import { BerthProvider } from './context/BerthContext';
import { QueryParamsProvider } from 'odfjell-query-manager/QueryParamsContext';
import { PbiReportsContextProvider } from './context/PbiReportsContext';
import { StowageProvider } from './context/StowageContext';
import { BunkerProvider } from './context/BunkerContext';
import { StowageRuleProvider } from './context/StowageRuleContext';
import { ViolationsProvider } from './context/ViolationsContext';
import ResolutionSimulatorWrapper from './components/resolutionSimulatorWrapper/ResolutionSimulatorWrapper';
import { StowageSelectionProvider } from './context/StowageSelectionContext';
import { RetroactiveCargoModeProvider } from './context/RetroactiveCargoModeContext';

const AppContainer = styled.div`
    color: ${theme.legacyColors.darkBlue};
    height: 100%;
    overflow: hidden;
    min-width: ${theme.constants.appMinWidth};
`;

library.add([
    faSearch,
    faSearchPlus,
    faRotateLeft,
    faRotateRight,
    faTimesCircle,
    faShip,
    faList,
    faPlus,
    faMinus,
    faMinusCircle,
    faMinusSquare,
    faSignInAlt,
    faTimes,
    faSignOutAlt,
    faSort,
    faSortUp,
    faSortDown,
    faCog,
    faGripHorizontal,
    faUser,
    faUserCircle,
    faCheck,
    faCheckCircle,
    faArchive,
    faFileAlt,
    faCalendarCheck,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faChevronUp,
    faCodeBranch,
    faStarOfLife,
    faArrowCircleLeft,
    faThumbtack,
    faDolly,
    faCaretRight,
    faFill,
    faPencilAlt,
    faFilter,
    faWater,
    faBell,
    faWifi,
    faPen,
    faEdit,
    faPenSquare,
    faTrash,
    faArrowsAlt,
    faArrowCircleRight,
    faArrowLeft,
    faTimesCircle,
    faCircle,
    faNotEqual,
    faExclamationTriangle,
    faExclamation,
    faExclamationCircle,
    faSortAmountUp,
    faSlidersH,
    faSortAmountDown,
    faSortAmountDownAlt,
    faTh,
    faClock,
    faExchangeAlt,
    faInfoCircle,
    faExternalLinkAlt,
    faPrint,
    faProjectDiagram,
    faEnvelope,
    faQuestionCircle,
    faEllipsisV,
    faEllipsisH,
    faInfo,
    faBroom,
    faDatabase,
    faStar,
    faComment,
    faTemperatureHigh,
    faListOl,
    faCertificate,
    faTable,
    faChartLine,
    faArrowUp,
    faArrowDown,
    faAngleDoubleDown,
    faAngleDoubleLeft,
    faAngleDoubleUp,
    faAngleDoubleRight,
    faGasPump,
    faEye,
    faExternalLinkSquareAlt,
    faCompress,
    faBars,
    faWindowClose,
    faUpload,
    faBan,
    faSyncAlt,
    faHandPointer,
    faUpDownLeftRight,
    faWeightHanging,
    faScaleUnbalancedFlip,
    faCaretDown,
    faCopy,
    faShareFromSquare,
    faBook,
    faChevronCircleDown,
    faChevronCircleUp,
    faFilePdf,
    faFileExcel,
    faUndo,
    faArrowsAltH,
    faRefresh,
    faLock,
    faUnlock,
]);

const AppComponent = () => {
    return (
        <AppContextProvider>
            <ResolutionSimulatorWrapper>
                <div className="content">
                    <AppContainer>
                        <Toaster position="top-right" reverseOrder={false} />
                        <AppSettingsStateProvider>
                            <QueryParamsProvider>
                                <ConnectionProvider>
                                    <LoaderContextProvider>
                                        <AuthContextProvider>
                                            <UserSettingsContextProvider>
                                                <DateProvider>
                                                    <EventProvider>
                                                        <EventTypeProvider>
                                                            <RotationProvider>
                                                                <VesselProvider>
                                                                    <RetroactiveCargoModeProvider>
                                                                        <TankCleaningProvider>
                                                                            <CargoTempLogProvider>
                                                                                <VerificationProvider>
                                                                                    <AolProvider>
                                                                                        <BerthProvider>
                                                                                            <PbiReportsContextProvider>
                                                                                                <StowageProvider>
                                                                                                    <StowageSelectionProvider>
                                                                                                        <StowageRuleProvider>
                                                                                                            <ViolationsProvider>
                                                                                                                <BunkerProvider>
                                                                                                                    <AppRouter />
                                                                                                                </BunkerProvider>
                                                                                                            </ViolationsProvider>
                                                                                                        </StowageRuleProvider>
                                                                                                    </StowageSelectionProvider>
                                                                                                </StowageProvider>
                                                                                            </PbiReportsContextProvider>
                                                                                        </BerthProvider>
                                                                                    </AolProvider>
                                                                                </VerificationProvider>
                                                                            </CargoTempLogProvider>
                                                                        </TankCleaningProvider>
                                                                    </RetroactiveCargoModeProvider>
                                                                </VesselProvider>
                                                            </RotationProvider>
                                                        </EventTypeProvider>
                                                    </EventProvider>
                                                </DateProvider>
                                            </UserSettingsContextProvider>
                                        </AuthContextProvider>
                                    </LoaderContextProvider>
                                </ConnectionProvider>
                            </QueryParamsProvider>
                        </AppSettingsStateProvider>
                    </AppContainer>
                </div>
            </ResolutionSimulatorWrapper>
        </AppContextProvider>
    );
};

export default AppComponent;
